import React, {lazy, Suspense} from 'react';
import {Router, Switch, Redirect} from 'react-router-dom';

import {withWhiteLabelContext} from '../screens/ExpertHome/WhiteLabelContextProvider';
// import PropTypes from "prop-types";

// Floating:
// import ChatApp from "./components/chatComponents/chatApp";
// import ChatApp from "../widgetComponent/openWidgetComponent/ChatComponent/chatApp";

// Common
import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import {AppContext} from './Context';
import history from './history';
import './Main.css';
import '@fortawesome/fontawesome-free/css/all.css';
// import CallInPopupComponent from '../screens/CallInPopup/CallInPopupComponent';
import WidgetContainerComponent from '../screens/WidgetContainerComponent/WidgetContainerComponent';
import WidgetContextProvider from '../components/widgetComponent/widgetContextProvider';
import ToastWrapperComponent from '../components/common/genericComponents/redesign/toastWrapperComponent/toastWrapperComponent';
import VIDABOO_CONSTANTS from '../config/consts';
import NotificationComponent from '../components/common/genericComponents/notificationComponent';
import EmailOptOutScreen from '../screens/emailOptOutScreen/emailOptOutScreen';
import ResellerMainController from './ResellerMainController';
// import AnimatedLogoComponent from '../components/common/genericComponents/animatedLogoComponent';

const PublicMediaScreen = lazy(
  () => import('../screens/PublicMediaScreen/publicMediaScreen'),
);

const ExpertHome = lazy(
  () => import('../screens/ExpertHome/ExpertHomeComponent'),
);

const ResellerAgencyHomeComponent = lazy(
  () => import('../screens/resellerAgency/resellerAgencyHomeComponent'),
);

const AuthenticationScreen = lazy(
  () => import('../screens/AuthenticationScreen/AuthenticationScreen'),
);

const AnonymousSchedulingScreen = lazy(
  () =>
    import('../screens/anonymousSchedulingScreen/anonymousSchedulingScreen'),
);
// const TestScreen = lazy(() => import('../screens/TestScreen/TestScreen'));

const GiftPage = lazy(
  () => import('../screens/redeemGiftsScreen/redeemGiftsComponent'),
);

const MeetingRoomScreen = lazy(
  () => import('../screens/meetingRoomScreen/meetingRoomScreen'),
);

// import AnimatedLogoComponent from "../components/common/genericComponents/animatedLogoComponent";
// import PublicMediaScreen from '../screens/PublicMediaPlayer/publicMediaScreen';
// 1. user changes Route (either goes to another link OR refreshes browser(F5))
// 2. webapp should refresh "currentUser" by accessing requireAuth
// 3. after requireAuth returns a value (could be async), we check whether we may access

class Main extends React.Component {
  // ...
  componentDidMount = async () => {
    // check if we're in
    await this.context.authenticationService.requireAuth();
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', this.handleSWMessage);
    }
  };

  componentWillUnmount() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener(
        'message',
        this.handleSWMessage,
      );
    }
  }

  handleSWMessage = (event) => {
    if (event?.data?.type === 'ping-from-sw') {
      // console.debug('Message from SW: ', event.data);
      if (navigator?.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'pong-from-page',
          pingTimestamp: event.data.timestamp,
          timestamp: Date.now(),
          message: 'IM_ALIVE',
        });
      }
    }
  };

  render() {
    return (
      <AppContext.Consumer>
        {(context) => {
          if (context.getCurrentUser().userId === undefined) return;

          let {isAuthorised} = context;
          return (
            <Suspense
              fallback={
                <div
                  style={{
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'start',
                    width: '150px',
                    textAlign: 'center',
                    color: '#2d2756',
                    fontWeight: 'bold',
                  }}>
                  {/* <AnimatedLogoComponent fillColor="#2d2756" /> */}
                  Loading....
                </div>
              }>
              <Router history={history}>
                <main className="pageContainer">
                  <WidgetContextProvider>
                    <ResellerMainController />
                    <Switch>
                      {/* BACKOFFICE SIDE:  */}
                      <PrivateRoute
                        isAuthorised={isAuthorised}
                        path={VIDABOO_CONSTANTS.PRIVATE_ROUTES_PATH.EXPERT_HOME}
                        component={ExpertHome}
                      />
                      <PrivateRoute
                        isAuthorised={isAuthorised}
                        path={VIDABOO_CONSTANTS.PRIVATE_ROUTES_PATH.SUB_ACCOUNT}
                        component={ExpertHome}
                      />
                      <PrivateRoute
                        isAuthorised={isAuthorised}
                        path={
                          VIDABOO_CONSTANTS.PRIVATE_ROUTES_PATH.RESELLER_AGENCY
                        }
                        component={ResellerAgencyHomeComponent}
                      />
                      <PublicRoute
                        exact
                        path="/login"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/redeemGift"
                        component={GiftPage}
                      />
                      <PublicRoute
                        exact
                        path="/emaildigest/:token"
                        component={EmailOptOutScreen}
                      />
                      <PublicRoute
                        exact
                        path={VIDABOO_CONSTANTS.ACTIVATION_ROUTES.APPSUMO}
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path={
                          VIDABOO_CONSTANTS.ACTIVATION_ROUTES.AGENCY_CUSTOMER
                        }
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path={VIDABOO_CONSTANTS.ACTIVATION_ROUTES.AGENCY_MEMBER}
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/registration"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/forgotpassword"
                        component={AuthenticationScreen}
                      />
                      <PublicRoute
                        exact
                        path="/resetpassword"
                        component={AuthenticationScreen}
                      />
                      <Redirect
                        exact
                        from="/crid/:crid"
                        to="/expertHome/chatCenter/:crid"
                      />
                      <Redirect
                        exact
                        from="/bpid/:bpid"
                        to="/expertHome/settings/billingPlanId/:bpid"
                      />
                      <Redirect
                        exact
                        from="/calid/:bfiId"
                        to={{
                          pathname: '/expertHome/calendar/:bfiId',
                          search: history.location.search,
                        }}
                        // to="/expertHome/calendar/:bfiId"
                      />
                      {/* https://my-ip.yuvidio.com:3000/stripe-account-onboarding-complete?scope=read_write&code=ac_QTiIPqN68HMEKZeUR5CxnNLPfRDs0Hm4 */}
                      <Redirect
                        exact
                        from={
                          VIDABOO_CONSTANTS.STRIPE_C2C_ONBOARDING_REDIRECT_PATH
                        }
                        to={{
                          pathname:
                            '/expertHome/settings/widgetSetup/setUpInstallation/paymentGateways',
                          search: history.location.search,
                        }}
                      />
                      {/* https://my-ip.yuvidio.com:3000/outlook-auth-callback?code=M.C539_BL2.2.U.26104cb0-e9ac-d3e2-2913-abb4b91fb35d */}
                      <Redirect
                        exact
                        from={VIDABOO_CONSTANTS.OUTLOOK_AUTH_REDIRECT_PATH}
                        to={{
                          pathname:
                            '/expertHome/settings/personalSettings/integrations',
                          search: history.location.search,
                          state: {
                            redirectPathType:
                              VIDABOO_CONSTANTS.AUTH_REDIRECT_PATH_TYPE.OUTLOOK,
                          },
                        }}
                      />
                      <Redirect
                        exact
                        from="/sauid/:sauid"
                        to="/subAccount/settings/:sauid"
                      />
                      {/* END BACKOFFICE SIDE */}
                      {/* CLIENT SIDE:  */}
                      {/* https://my-ip.yuvidio.com:3000/gmail-auth-callback?code=4/0AQlEd8xG2VFMDMi8gwa8AWONyNuZZte3bsM_Jd2jEVABiDtdH2JZxQq69_wvYbKBZttpRg&scope=https://mail.google.com/ */}
                      <Redirect
                        exact
                        from={VIDABOO_CONSTANTS.GOOGLE_EMAIL_AUTH_REDIRECT_PATH}
                        to={{
                          pathname:
                            '/expertHome/settings/personalSettings/integrations',
                          search: history.location.search,
                          state: {
                            redirectPathType:
                              VIDABOO_CONSTANTS.AUTH_REDIRECT_PATH_TYPE
                                .GOOGLE_EMAIL,
                          },
                        }}
                      />
                      <PublicRoute
                        path="/m/:shortId"
                        component={MeetingRoomScreen}
                      />
                      <PublicRoute
                        path="/mb/:bfiId"
                        component={MeetingRoomScreen}
                      />
                      <PublicRoute
                        exact
                        path="/expertWidget/wid/:widgetId"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        exact
                        path="/expertDir/wid/:widgetId"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        path="/expertWidget/:mentorProfileName"
                        component={WidgetContainerComponent}
                      />
                      {/* <PublicRoute
                        path="/clickntalk/:mentorProfileName"
                        component={WidgetContainerComponent}
                      /> */}
                      <PublicRoute
                        path="/expert/:mentorProfileName"
                        component={WidgetContainerComponent}
                      />
                      <PublicRoute
                        exact
                        path="/cs/:bfiId"
                        component={AnonymousSchedulingScreen}
                      />
                      <PublicRoute
                        exact
                        path="/media/:publicMediaAccessString"
                        component={PublicMediaScreen}
                      />
                      {/* <PublicRoute
                        exact
                        path="/testScreen"
                        component={TestScreen}
                      /> */}
                      {/* <Redirect
                        exact
                        path="/expert/:mentorProfileName"
                        to={{
                          pathname: '/clickntalk/:mentorProfileName',
                          search: history.location.search,
                        }}
                      /> */}
                      {/* END CLIENT SIDE:  */}
                      <Redirect from="/" to="/expertHome/overview" />
                    </Switch>
                  </WidgetContextProvider>
                </main>
                {context.showNotificationPopUp && ( //todo : review with Ilan
                  <NotificationComponent
                    {...context.notificationPopUpData}
                    closeBtnFunc={
                      context.notificationPopUpData.closeBtnFunc ??
                      context.closeNotificationPopUp
                    }
                  />
                )}
                <ToastWrapperComponent />
              </Router>
              <div id="et-top-level-popup-portal-wrapper" dir="auto" />
            </Suspense>
          );
        }}
      </AppContext.Consumer>
    );
  }
}

Main.contextType = AppContext;
export default withWhiteLabelContext(Main);
